export const formatDurationTest = (duration) => {
    if (!duration || typeof duration !== 'string') {
        return '00hrs 00min'; // Default or fallback value in case duration is missing
    }
    const [hours, minutes] = duration.split(':');
    const formattedHours = parseInt(hours, 10).toString();
    const formattedMinutes = parseInt(minutes, 10).toString().padStart(2, '0');

    return `${formattedHours}hrs ${formattedMinutes}min`;
};

export const formatDuration = (duration,t) => {
    if (!duration || typeof duration !== 'string') {
        return `0 ${t('secTime')}`; // Default or fallback value in case duration is missing
    }
    
    const [hours, minutes, seconds] = duration.split(':');
    const formattedHours = parseInt(hours, 10);
    const formattedMinutes = parseInt(minutes, 10);
    const formattedSeconds = parseInt(seconds, 10);

    const parts = [];

    if (formattedHours > 0) parts.push(`${formattedHours} ${t('hrsTime')}`);
    if (formattedMinutes > 0) parts.push(`${formattedMinutes} ${t('minTime')}`);
    if (formattedSeconds > 0) parts.push(`${formattedSeconds} ${t('secTime')}`);

    return parts.length > 0 ? parts.join(' ') : `0 ${t('secTime')}`;
};